import { FormList, FormUnit } from "@suse-o11y/signal/form";

import type { DashboardVariable } from "../../common/dashboard-spec";

type VariableFormState = FormUnit<DashboardVariable, string>;

function initVariable(variable: DashboardVariable): VariableFormState {
	return FormUnit<DashboardVariable, string>(variable, {
		isInputEqual: (left, right) => left.isEqual(right),
	});
}

type FormState = FormList<VariableFormState>;

function init(variables: ReadonlyArray<DashboardVariable>): FormState {
	return FormList(initVariable, {
		initial: variables,
	});
}

export type { FormState, VariableFormState };
export { init };
